import {
  EntityList,
  EntityListProps,
  renderDate,
  renderEnum,
  renderMultiPersonas,
  renderNewMailIcon,
  renderStatusIcon,
} from 'components/EntityList'
import { Proving, UserRole } from 'gql.generated'
import { useAuthContext } from 'hooks/useAuthContext'
import {
  ConstrainMode,
  PersonaSize,
  SelectionMode,
} from 'office-ui-fabric-react'
import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { createFieldColumn } from 'views/helpers'

type ReadProvings_workers = any

// interface ListSettings {
//   compact: boolean
// }

export type TaskListProps = EntityListProps<ReadProvings_workers>

export const TaskList: React.FunctionComponent<TaskListProps> = ({
  items,
  ...props
}) => {
  const { t } = useTranslation()
  const auth = useAuthContext()
  const isAdmin = auth.hasUserRole(UserRole.SystemAdministrator)
  const isResourceManager = auth.hasUserRole(UserRole.ResourceManager)
  const isProvingOrganisation = auth.hasUserRole(UserRole.ProvingOrganisation)
  const isHrg = auth.hasUserRole(UserRole.Hrg)
  const isServiceTeam = auth.hasUserRole(UserRole.ServiceTeam)

  const canSeeNewMailsColumn = isAdmin
    ? true
    : isResourceManager
    ? true
    : isProvingOrganisation
    ? true
    : isHrg
    ? true
    : isServiceTeam
    ? true
    : false

  const canSeeHrgEditorColumn = isAdmin || isHrg || isProvingOrganisation

  // const [listSettings] = useSettings<ListSettings>('list', {
  //   compact: false,
  // })

  const fieldColumn = React.useMemo(() => createFieldColumn(t), [t])
  const columns = React.useMemo(
    () => [
      fieldColumn('status', {
        onRender: renderStatusIcon,
        getGroupValue: (item: Proving) => {
          return item.hasIncompleteBookings
            ? t(`enum.todo.${item.status}`) +
                ' (Buchungen noch teilweise offen)'
            : t(`enum.todo.${item.status}`)
        },
        minWidth: 40,
        maxWidth: 60,
        isGrouped: true,
      }),
      fieldColumn('provingGround.title', {
        onRender: (item, i, col) => {
          return `${item.provingGround!.title}, ${
            item.provingGround!.countryCode
          }`
        },
        ungroupable: true,
        getGroupValue: (item: Proving) =>
          `${item.provingGround!.title}, ${item.provingGround!.countryCode}`,
      }),
      fieldColumn('dateFrom', {
        onRender: renderDate,
        ungroupable: true,
      }),
      fieldColumn('dateTo', {
        onRender: renderDate,
        ungroupable: true,
      }),
      fieldColumn('title', {
        ungroupable: true,
        minWidth: 320,
      }),
      fieldColumn('id', {
        ungroupable: true,
      }),
      fieldColumn('status', {
        onRender: renderEnum(t, 'status'),
        // getGroupValue: (item: Proving) => {
        //   return item.hasIncompleteBookings
        //     ? t(`enum.todo.${item.status} (Buchungen noch teilweise offen)`)
        //     : t(`enum.todo.${item.status}`)
        // },
        minWidth: 40,
        maxWidth: 60,
        isGrouped: true,
      }),
      ...(canSeeHrgEditorColumn
        ? [
            fieldColumn('hrgEditor', {
              onRender: renderMultiPersonas({ size: PersonaSize.size8 }),
              ungroupable: true,
              minWidth: 100,
            }),
          ]
        : []),
    ],
    [fieldColumn, t]
  )

  const newMailColumn = fieldColumn('newMails', {
    onRender: renderNewMailIcon,
    getGroupValue: (item: Proving) => {
      return item.newMails && item.newMails > 0
        ? 'Erprobungen mit neuen Mails'
        : 'Erprobungen ohne Neuigkeiten'
    },
  })

  if (canSeeNewMailsColumn && !columns.find((c) => c.key === 'newMails')) {
    columns.push(newMailColumn)
  }

  return (
    <EntityList
      alternate={true}
      stickyHeader={true}
      selectionMode={SelectionMode.multiple}
      items={items}
      constrainMode={ConstrainMode.horizontalConstrained}
      columns={columns}
      {...props}
    />
  )
}
